import React from 'react';
import PropTypes from 'prop-types';

import { memo } from 'react';
import LeftNavChild from './LeftNavChild';

const LeftNavList = ({ navItems, setSupportNav, activeParentNav, toggleParentNav }) => {
  let leftNavList = null;
  if (navItems.length > 0) {
    leftNavList = navItems.map((nav, i) => {
      const { name, children, title } = nav;
      let listClassName = 'mri-support-navigation--list-item';
      let listLinkClassName = 'mri-support-navigation--link';
      if (nav.active) {
        listClassName += '  mri-support-navigation--active';
        listLinkClassName += ' mri-support-navigation--link--active';
      }
      let button = (<button className={listLinkClassName} onClick={() => setSupportNav(name)}
       type="button">{title}</button>);
      if (children.length > 0) {
        listClassName = activeParentNav[name]
          ? 'mri-support-navigation--list-item mri-support-navigation--dropdown-active'
          : 'mri-support-navigation--list-item mri-support-navigation--dropdown';
        button = (
          <button className={`toggle_sub_nav ${listLinkClassName}`} 
          onClick={() => toggleParentNav(name)} type="button">{title}</button>
        );
      }
      return (
        <li id={`${i}_${name}`} key={`${i}_${name}`} className={listClassName}>
          {button}
          <LeftNavChild
            nav={nav}
            index={i}
            setSupportNav={setSupportNav}
            activeParentNav={activeParentNav}
          />
        </li>
      );
    });
  }

  return <ul className="mri-support-navigation--list">{leftNavList}</ul>;
};

LeftNavList.propTypes = {
  navItems: PropTypes.instanceOf(Array),
  setSupportNav: PropTypes.func,
  activeParentNav: PropTypes.instanceOf(Object),
  toggleParentNav: PropTypes.func,
};

export default memo(LeftNavList);
